/** Only development builds on loopback may skip Firebase or call local paid AI. */
import { allowsLocalDemo } from "./local-demo-policy";
export { allowsLocalDemo } from "./local-demo-policy";
export const localDemoEnabled = allowsLocalDemo(import.meta.env.DEV, import.meta.env.VITE_LOCAL_DEMO, typeof window === "undefined" ? "" : window.location.hostname);
